import type { AxiosRequestConfig } from 'axios';
import {
  apiPatch,
  apiPost,
} from '~/_shared/utils/api/api.helpers';

// keepalive lets the request outlive the page, e.g. when it is sent while the browser tab is being closed
const keepaliveRequestConfig: AxiosRequestConfig = {
  adapter: 'fetch',
  fetchOptions: { keepalive: true },
};

export type RatingRequestOptions = Readonly<{
  keepalive?: boolean;
}>;

export type RatingResponse = Readonly<{
  id: number;
  rating: number;
  comment: string | null;
  created_at: string;
}>;

export type CreateRatingRequest = Readonly<{
  rating: number;
  comment?: string;
}>;

export type AddRatingCommentRequest = Readonly<{
  comment: string | null;
}>;

export const createRating = (
  clientId: number, payload: CreateRatingRequest, { keepalive }: RatingRequestOptions = {}
): Promise<{ readonly data: RatingResponse }> =>
  apiPost(`/api/clients/${clientId}/rating`, payload, keepalive ? keepaliveRequestConfig : undefined);

export const addRatingComment = (clientId: number, ratingId: number, payload: AddRatingCommentRequest): Promise<{ readonly data: RatingResponse }> =>
  apiPatch(`/api/clients/${clientId}/rating/${ratingId}`, payload);

export const dismissRating = (clientId: number): Promise<void> =>
  apiPost(`/api/clients/${clientId}/rating/dismiss`);
